import { render } from "./TanaoroshiInventoryDateDialog.vue?vue&type=template&id=3a8e6640"
import script from "./TanaoroshiInventoryDateDialog.vue?vue&type=script&lang=js"
export * from "./TanaoroshiInventoryDateDialog.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3657311707/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__